import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const StarFillBase = (
  <path
    fill='currentColor'
    d='M15.468 6.243c-.077-.231-.286-.398-.557-.446l-4.223-.737c-.012-.005-.033-.019-.042-.03L8.61 1.377C8.48 1.14 8.252 1 8 1s-.48.14-.61.375L5.357 5.028c-.009.01-.032.027-.027.027l-4.241.742c-.27.048-.479.214-.557.445-.078.23-.01.484.18.678l2.986 3.03-.58 4.127c-.036.264.062.507.266.65.113.08.248.12.387.12.11 0 .225-.026.335-.078l3.866-1.8c.013-.004.043-.004.04-.007l3.883 1.808c.249.115.518.099.721-.044.203-.142.303-.385.265-.65l-.577-4.11c0-.011.008-.037.006-.037l2.977-3.009c.192-.193.26-.446.181-.677z'
  />
)

export const StarFill = createIcon({
  displayName: 'StarFill',
  viewBox: '0 0 16 16',
  path: StarFillBase,
})

export const StarOutlineBase = (
  <path
    fill='transparent'
    stroke='currentColor'
    d='M14.91 5.797c.272.048.48.215.558.446.078.231.01.484-.18.677l-2.63 2.657c-.22.222-.323.534-.28.843.22 1.584.503 3.656.503 3.656.037.265-.062.508-.265.65-.203.143-.472.16-.72.044l-3.463-1.612c-.267-.124-.575-.124-.842-.001l-3.485 1.612c-.11.052-.225.077-.335.077-.14 0-.274-.04-.387-.12-.204-.142-.302-.385-.266-.65l.511-3.637c.043-.308-.06-.62-.278-.841L.71 6.92c-.19-.194-.257-.448-.179-.678.078-.23.286-.397.557-.445l3.802-.685c.295-.053.55-.236.696-.498L7.39 1.375C7.52 1.141 7.748 1 8 1s.48.14.61.376l2.036 3.655c.01.01.03.024.041.029l4.224.737z'
  />
)

export const StarOutline = createIcon({
  displayName: 'StarOutline',
  viewBox: '0 0 16 16',
  path: StarOutlineBase,
})
